import DataTableColumnHeader from '@/components/datatable/DataTableColumnHeader.vue';
import SalaryLogContent from '@/components/salary/SalaryLogContent.vue';
import { useDateFormat } from '@/composables/useDateFormat';
import type { SalaryLog } from '@/types';
import type { ColumnDef } from '@tanstack/vue-table';
import { h } from 'vue';

const { formatDMYHSFromIso } = useDateFormat();

export const columns: ColumnDef<SalaryLog>[] = [
    {
        accessorKey: 'date',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'payrolls.activity_log.table.date',
            }),
        cell: ({ row }) => {
            return formatDMYHSFromIso(row.original.date);
        },
        filterFn: 'dateRange',
        meta: {
            filterType: 'dateRange',
        },
    },
    {
        accessorKey: 'subject',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'payrolls.activity_log.table.subject',
            }),
    },
    {
        accessorKey: 'user',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'payrolls.activity_log.table.user',
            }),
    },
    {
        accessorKey: 'description',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'payrolls.activity_log.table.description',
            }),
    },
    {
        accessorKey: 'content',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'payrolls.activity_log.table.content',
            }),
        cell: ({ row }) => h(SalaryLogContent, { content: row.original.content }),
    },
];
